import { observable, makeObservable, action } from 'mobx';
import {
  SEARCH_PARAMS,
  WIX_DEFAULT_PARENT_ACCOUNT_ID,
} from '../utils/constants';
import { RootStore } from './root';
import { ROUTES } from '../routes';
import { SIGNUP_EMAIL_STORAGE_KEY } from './constants';
import { normalizeEmail } from '../utils/general';

export const SSO_PROVIDERS = {
  YELL: 'YELL',
};

export class UserDataStore {
  private readonly rootStore: RootStore;
  public email: string;
  public currentLoggedInEmail: string;
  /**
   * Parent account of the account an email resolved to, with that email: the
   * login form lets the email be edited without a new lookup.
   */
  private resolvedAccount?: { email: string; parentAccountId: string };

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    this.currentLoggedInEmail = window.__CURRENT_LOGGED_IN_USER_EMAIL__;
    this.email = this.getInitialEmailValue();
    makeObservable(this, {
      email: observable,
      setEmail: action.bound,
      setResolvedAccount: action.bound,
      clearResolvedAccount: action.bound,
    });
  }

  setEmail(email: string) {
    this.email = email;
  }

  /** Accounts directly under Wix may come back without a parent. */
  setResolvedAccount(email: string, account?: { parentAccountId?: string }) {
    this.resolvedAccount = account
      ? {
          email: normalizeEmail(email),
          parentAccountId:
            account.parentAccountId || WIX_DEFAULT_PARENT_ACCOUNT_ID,
        }
      : undefined;
  }

  clearResolvedAccount() {
    this.resolvedAccount = undefined;
  }

  /** The resolved account's parent, only while logging in with the email it was resolved for. */
  parentAccountIdFor(email?: string) {
    return email && this.resolvedAccount?.email === normalizeEmail(email)
      ? this.resolvedAccount.parentAccountId
      : undefined;
  }

  private getInitialEmailValue() {
    if (
      this.rootStore.navigationStore.currentRoute === ROUTES.SIGNUP_EMAIL_CODE
    ) {
      try {
        const email = sessionStorage.getItem(SIGNUP_EMAIL_STORAGE_KEY);
        if (email) {
          return email;
        }
      } catch (_) {}
    }
    const emailFromUrl =
      this.rootStore.navigationStore.getQueryParam(SEARCH_PARAMS.EMAIL) ||
      this.rootStore.navigationStore.getQueryParam(
        SEARCH_PARAMS.DEFAULT_EMAIL,
      ) ||
      '';
    return emailFromUrl.replace(/ /g, '+');
  }
}
